import { callExternalApi, CallResult } from '../callExternalApi';
import { AdviseEngagement } from '../../types/advise';

const overrideUrl = (id: string) => `api/advise/engagements/${id}/current_spend/override`;

export const updateAdviseCurrentSpendOverride = async (
  id: string,
  monthlyAmount: number
): Promise<CallResult<AdviseEngagement>> => {
  return callExternalApi<AdviseEngagement>({
    url: overrideUrl(id),
    method: 'PUT',
    headers: { 'content-type': 'application/json' },
    data: { monthly_amount: monthlyAmount }
  });
};

export const deleteAdviseCurrentSpendOverride = async (id: string): Promise<CallResult<AdviseEngagement>> => {
  return callExternalApi<AdviseEngagement>({
    url: overrideUrl(id),
    method: 'DELETE',
    headers: { 'content-type': 'application/json' }
  });
};
